import Cookies from 'js-cookie';

import actions from '@/store/modules/user/actions'
import getters from '@/store/modules/user/getters';
import mutations from '@/store/modules/user/mutations'
import { safeParseJSON } from '@/utils/safeParseJSON'


function resolveSetPanelFromCookie() {
    const panel = Cookies.get('setPanel');
    if (!panel || panel === '0') {
        return null;
    }
    const user = safeParseJSON('user', {});
    if (user.id != null && String(panel) === String(user.id)) {
        Cookies.remove('setPanel');
        Cookies.remove('setPanelName');
        Cookies.remove('setPanelPermission');
        return null;
    }
    return panel;
}

const state = {
    user: safeParseJSON('user', {}),
    verifyEmail: (String(Cookies.get('verify_email')) == "true"),
    userClub: (String(Cookies.get('club_integration')) == "true"),
    setPanel: resolveSetPanelFromCookie(),
}


export {
    state,
    getters,
    actions,
    mutations,
}